import { useMediaQuery } from 'react-responsive';

import { deviceSizes } from '@repo/styles';

export default function useCheckMediaQuery() {
  const isXSmall = useMediaQuery({ minWidth: deviceSizes.xsmall });
  const isMobile = useMediaQuery({ minWidth: deviceSizes.small });
  const isLaptop = useMediaQuery({ minWidth: deviceSizes.medium + 1 });
  const isDesktop = useMediaQuery({ minWidth: deviceSizes.large + 1 });
  const isXLarge = useMediaQuery({ minWidth: deviceSizes.xLarge + 1 });

  return { isMobile, isLaptop, isDesktop, isXLarge, isXSmall };
}
